import { render, staticRenderFns } from "./OUserList.vue?vue&type=template&id=fdb7e968&"
import script from "./OUserList.vue?vue&type=script&lang=ts&"
export * from "./OUserList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports